module.exports = __webpack_public_path__ + "static/media/choka1.f3162ea5.jpeg";